import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import A4Invoice from "./a4nvoice";
import ThermalInvoice from "./ThermalInvoice";
import { PrinterOutlined, CreditCardOutlined } from "@ant-design/icons";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import InvoiceA5 from "./a5Invoice";
import { Button, Modal, Select, Radio, Space } from "antd";
import { get_invoice } from "../../../../Controllers/Sales/Invoices";
import Header from "../../../../Componets/Header";
import headers from "../../../../Data/Forms/Billings/Billings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import InvoiceA5Header from "./a5InvoiceHeader";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";
import PaymentReceipt from "./PaymentReceipt";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const { Option } = Select;

const BillingView = (props) => {
  let { id } = useParams();
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const invoiceA4Ref = useRef();
  const invoiceRef = useRef();
  const invoiceA5Ref = useRef();
  const invoiceA5HeaderRef = useRef();
  const paymentReceiptRef = useRef();

  const handleA4Print = useReactToPrint({
    content: () => invoiceA4Ref.current,
  });

  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current,
  });

  const handleA5Print = useReactToPrint({
    content: () => invoiceA5Ref.current,
  });

  const handleA5HeaderPrint = useReactToPrint({
    content: () => invoiceA5HeaderRef.current,
  });

  const handlePaymentReceiptPrint = useReactToPrint({
    content: () => paymentReceiptRef.current,
  });

  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState();
  const [header, setHeader] = useState(headers);
  const [returnPage, setReturnPage] = useState(1);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState('single');
  const [allPaymentsSelected, setAllPaymentsSelected] = useState([]);

  const getFilteredPayments = () => {
    if (!values?.payment_logs) return [];
    return values.payment_logs.filter(payment => payment.amount > 0);
  };

  const calculateTotalPaid = () => {
    const filteredPayments = getFilteredPayments();
    return filteredPayments.reduce((sum, payment) => sum + (payment.amount || 0), 0);
  };

  const calculateRemainingBalance = () => {
    const totalPaid = calculateTotalPaid();
    return (values?.total || 0) - totalPaid;
  };

  const handleData = (invoice) => {
    setValues(invoice);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);

      if (invoice?.status) {
        handleData(invoice?.data);
      } else {
        toast?.error(invoice?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleBack = () => {
    const page = returnPage || 1;
    navigate(`/app/billing?page=${page}`);
  };

  useEffect(() => {
    fetchData();
    const pageParam = searchParams.get('returnPage');
    if (pageParam) {
      setReturnPage(parseInt(pageParam));
    }
  }, [id, searchParams]);

  const handlePaymentPrintClick = () => {
    const filteredPayments = getFilteredPayments();

    if (filteredPayments.length === 0) {
      toast.error("No payments found for this invoice");
      return;
    }

    setSelectedPayment(null);
    setSelectedPaymentType('single');
    setAllPaymentsSelected([]);
    setPaymentModalVisible(true);
  };

  const handlePaymentSelect = (paymentId) => {
    setSelectedPayment(paymentId);
  };

  const handleAllPaymentsSelect = (checked, paymentId) => {
    if (checked) {
      setAllPaymentsSelected([...allPaymentsSelected, paymentId]);
    } else {
      setAllPaymentsSelected(allPaymentsSelected.filter(id => id !== paymentId));
    }
  };

  const handleSelectAllPayments = () => {
    const filteredPayments = getFilteredPayments();
    if (allPaymentsSelected.length === filteredPayments.length) {
      setAllPaymentsSelected([]);
    } else {
      const allIds = filteredPayments.map(p => p._id);
      setAllPaymentsSelected(allIds);
    }
  };

  const handlePrintPaymentReceipt = () => {
    const filteredPayments = getFilteredPayments();

    if (selectedPaymentType === 'single' && !selectedPayment) {
      toast.error("Please select a payment");
      return;
    }

    if (selectedPaymentType === 'all' && allPaymentsSelected.length === 0) {
      toast.error("Please select at least one payment");
      return;
    }

    setPaymentModalVisible(false);

    setTimeout(() => {
      handlePaymentReceiptPrint();
    }, 100);
  };

  const getSelectedPaymentData = () => {
    const filteredPayments = getFilteredPayments();

    if (selectedPaymentType === 'single') {
      return filteredPayments?.find(p => p._id === selectedPayment);
    } else {
      return filteredPayments?.filter(p => allPaymentsSelected.includes(p._id));
    }
  };

  const filteredPayments = getFilteredPayments();
  const totalPaid = calculateTotalPaid();
  const remainingBalance = calculateRemainingBalance();

  return (
    <Header headers={header} setHeaders={setHeader} >
      <Loadercomponent loader={loader}>

        <div className="pb-8">
          <div className="flex justify-end flex-wrap">
            <div className="p-2" onClick={handleBack}>
              <Button size="large">
                <div className="flex">
                  <div> Back </div>
                </div>
              </Button>
            </div>
            <div className="p-2" onClick={handlePaymentPrintClick}>
              <Button
                size="large"
                icon={<CreditCardOutlined />}
                disabled={filteredPayments.length === 0}
              >
                Payment Receipt ({filteredPayments.length})
              </Button>
            </div>
            <div className="p-2" onClick={handleA4Print}>
              <Button size="large">
                A4 Print <PrinterOutlined className="text-lg" />
              </Button>
            </div>
            <div className="pt-2 " onClick={handlePrint}>
              <Button size="large">
                Thermal Print <PrinterOutlined className="text-lg" />
              </Button>
            </div>
            <div className="p-2" onClick={handleA5Print}>
              <Button size="large">
                A5 Print <PrinterOutlined className="text-lg" />
              </Button>
            </div>
            <div className="p-2" onClick={handleA5HeaderPrint}>
              <Button size="large">
                A5 Header Print <PrinterOutlined className="text-lg" />
              </Button>
            </div>
          </div>
        </div>

        <Modal
          title="Select Payment(s) for Receipt"
          open={paymentModalVisible}
          onCancel={() => setPaymentModalVisible(false)}
          width={600}
          footer={[
            <Button key="close"
              type="primary"
              className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
              onClick={() => setPaymentModalVisible(false)}>
              Cancel
            </Button>,
            <Button
              key="print"
              type="primary"
              onClick={handlePrintPaymentReceipt}
              className="mr-2 !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
              disabled={
                (selectedPaymentType === 'single' && !selectedPayment) ||
                (selectedPaymentType === 'all' && allPaymentsSelected.length === 0)
              }
            >
              Print Receipt
            </Button>,
          ]}
        >
          <div className="space-y-4">
            <div className="mb-4 p-3 bg-green-50 rounded">
              <div className="text-sm text-green-700">
                <strong>Invoice Total:</strong> {values?.total?.toFixed(3)} OMR |
                <strong> Paid:</strong> {totalPaid.toFixed(3)} OMR |
                <strong> Balance:</strong> {remainingBalance.toFixed(3)} OMR
              </div>
            </div>

            <div>
              <Radio.Group
                value={selectedPaymentType}
                onChange={(e) => setSelectedPaymentType(e.target.value)}
                className="w-full"
              >
                <Space direction="vertical">
                  <Radio value="single">Print Single Payment Receipt</Radio>
                  <Radio value="all">Print Multiple Payment Receipts</Radio>
                </Space>
              </Radio.Group>
            </div>

            {selectedPaymentType === 'single' && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select Payment
                </label>
                <Select
                  placeholder="Select a payment"
                  value={selectedPayment}
                  onChange={handlePaymentSelect}
                  style={{ width: '100%' }}
                  size="large"
                >
                  {filteredPayments.map((payment, index) => (
                    <Option key={payment._id} value={payment._id}>
                      {payment.name} - {payment.amount.toFixed(3)} OMR
                      ({formatDateDDMMYYYY(payment.created || payment.createdAt)})
                    </Option>
                  ))}
                </Select>
              </div>
            )}

            {selectedPaymentType === 'all' && (
              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Select Multiple Payments ({filteredPayments.length} payments available)
                  </label>
                  <Button
                    className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                    type="primary"
                    size="small"
                    onClick={handleSelectAllPayments}
                  >
                    {allPaymentsSelected.length === filteredPayments.length ?
                      'Deselect All' : 'Select All'}
                  </Button>
                </div>

                <div className="border rounded-lg max-h-60 overflow-y-auto">
                  {filteredPayments.map((payment, index) => (
                    <div
                      key={payment._id}
                      className="p-3 hover:bg-gray-50 flex items-center border-b last:border-b-0"
                    >
                      <input
                        type="checkbox"
                        checked={allPaymentsSelected.includes(payment._id)}
                        onChange={(e) => handleAllPaymentsSelect(e.target.checked, payment._id)}
                        className="mr-3 h-4 w-4"
                      />
                      <div className="flex-1">
                        <div className="font-medium">{payment.name}</div>
                        <div className="text-sm text-gray-500">
                          Amount: {payment.amount.toFixed(3)} OMR |
                          Date: {formatDateDDMMYYYY(payment.created || payment.createdAt)}
                        </div>
                      </div>
                      <div className="text-sm font-medium">
                        #{index + 1}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-2 text-sm text-gray-600">
                  {allPaymentsSelected.length} of {filteredPayments.length} payments selected
                  {allPaymentsSelected.length > 0 && (
                    <span className="ml-2 text-green-600 font-medium">
                      Total: {filteredPayments
                        .filter(p => allPaymentsSelected.includes(p._id))
                        .reduce((sum, p) => sum + p.amount, 0)
                        .toFixed(3)} OMR
                    </span>
                  )}
                </div>
              </div>
            )}

          </div>
        </Modal>

        <div className="hidden-on-screen">
          <PaymentReceipt
            ref={paymentReceiptRef}
            invoice={values}
            payment={getSelectedPaymentData()}
            paymentType={selectedPaymentType}
            isMultiple={selectedPaymentType === 'all'}
            totalPaid={totalPaid}
            remainingBalance={remainingBalance}
          />
        </div>

        <ScrollWrapper>
          <div>
            <A4Invoice ref={invoiceA4Ref} values={values} />
          </div>
        </ScrollWrapper>


        <div className="hidden-on-screen">
          <ThermalInvoice ref={invoiceRef} values={values} />
        </div>

        <div className="hidden-on-screen">
          <InvoiceA5 ref={invoiceA5Ref} values={values} />
        </div>

        <div className="hidden-on-screen">
          <InvoiceA5Header ref={invoiceA5HeaderRef} values={values} />
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default BillingView;